/**
 * @Author: AI Assistant
 * @Date: 2026-07-22
 * @Description: 数字人模块路由配置
 */
const DigitalHumanList = () => import('@/views/digitalHuman/index.vue')
const ClientVersionList = () => import('@/views/clientVersion/index.vue')
const ClientModelList = () => import('@/views/clientModel/index.vue')
const SphereLoginReportList = () => import('@/views/sphereLoginReport/index.vue')
const DigitalHumanDetail = () => import('@/views/digitalHuman/detail.vue')
const SystemIntegrationConfig = () => import('@/views/workbench/cfo/SystemIntegrationConfig.vue')
const ClientGroupList = () => import('@/views/clientGroup/index.vue')
const CustomerMessageList = () => import('@/views/customerMessage/index.vue')
const SphereUserList = () => import('@/views/sphereUser/index.vue')
const SphereTenantList = () => import('@/views/sphereTenant/index.vue')
const SpherePackageList = () => import('@/views/spherePackage/index.vue')
const SphereCategoryList = () => import('@/views/sphereCategory/index.vue')
const SphereSkillPlatform = () => import('@/views/sphereSkill/platform.vue')
const SphereSkillEnterprise = () => import('@/views/sphereSkill/enterprise.vue')
const SphereAssistantList = () => import('@/views/sphereAssistant/index.vue')
const SphereSkillInstallRecord = () => import('@/views/sphereSkillInstall/index.vue')
const SphereConnectorList = () => import('@/views/connector/index.vue')
const Layout = () => import('@/views/index/index.vue')
const MenuLayout = () => import('@/components/layout/index.vue')

/** 数字人模块路由（嵌入在 / 的 Layout children 下） */
export default {
  path: '/digital-human',
  redirect: '/digital-human/digital-human-manage',
  component: Layout,
  children: [
    {
      path: 'digital-human-manage',
      name: 'DigitalHumanManage',
      component: MenuLayout,
      children: [
        {
          // 修改: 将 path 从 '/' 改为空字符串 ''
          path: '',
          component: DigitalHumanList,
          meta: {
            name: '数字人',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        },
        {
          path: 'detail',
          name: 'DigitalHumanDetail',
          component: DigitalHumanDetail,
          meta: {
            name: '数字人详情',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
      // component: () => import('@/views/portal/index.vue')
    },
    {
      path: 'system-integration-config',
      name: 'SystemIntegrationConfig',
      component: MenuLayout,
      children: [
        {
          // 修改: 将 path 从 '/' 改为空字符串 ''
          path: '',
          component: SystemIntegrationConfig,
          meta: {
            name: '业务系统集成配置',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true,
            keepSmartWorkspace: true
          }
        }
      ]
      // component: () => import('@/views/portal/index.vue')
    },
    {
      path: 'client-group',
      name: 'ClientGroupManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: ClientGroupList,
          meta: {
            name: '客户分组',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'customer-message-manage',
      name: 'CustomerMessageManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: CustomerMessageList,
          meta: {
            name: '客户留言与回访',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-user-manage',
      name: 'SphereUserManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereUserList,
          meta: {
            name: 'Sphere用户管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-tenant-manage',
      name: 'SphereTenantManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereTenantList,
          meta: {
            name: '团队管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-package-manage',
      name: 'SpherePackageManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SpherePackageList,
          meta: {
            name: '套餐管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'client-model-manage',
      name: 'ClientModelManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: ClientModelList,
          meta: {
            name: '模型管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'client-version-manage',
      name: 'ClientVersionManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: ClientVersionList,
          meta: {
            name: '客户端版本管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-category-manage',
      name: 'SphereCategoryManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereCategoryList,
          meta: {
            name: '分类管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'login-report-manage',
      name: 'LoginReportManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereLoginReportList,
          meta: {
            name: '用户登录情况',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-assistant-manage',
      name: 'SphereAssistantManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereAssistantList,
          meta: {
            name: '智能体管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-skill-platform',
      name: 'SphereSkillPlatformManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereSkillPlatform,
          meta: {
            name: '云端技能',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'sphere-skill-enterprise',
      name: 'SphereSkillEnterpriseManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereSkillEnterprise,
          meta: {
            name: '企业技能',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'skill-install-record',
      name: 'SphereSkillInstallRecordManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereSkillInstallRecord,
          meta: {
            name: 'Skill安装记录',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    },
    {
      path: 'connector-manage',
      name: 'SphereConnectorManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: SphereConnectorList,
          meta: {
            name: '连接器管理',
            context: 'digital-human',
            type: 'INNER_APP',
            canAccess: true
          }
        }
      ]
    }
  ]
}
